var exports = {
  "yh": "cliPickerContainer__gnFCaF",
  "yl": "cliInstallCta__bvKpBd",
  "Lf": "customInputContainer__QWi3JB",
  "pT": "customInputCopyButton__ADuQrX",
  "zM": "customInputCode__kbl316",
  "wC": "customInputCodeContainer__WGLgQX",
  "h0": "installMethodButton__mnp-0H",
  "IK": "customInputCopyIcon__C6UUSt",
  "HO": "cliMobile__GVPDM5",
};

module.exports = exports;
